class DocumentationController extends AbstractController
	@register()
	@inject 'PublicRepository'

	initialize: ->
		# @link https://redocly.com/docs/redoc/config/
		Redoc.init(
			@PublicRepository.getDocumentationUrl(),
			{
				nativeScrollbars: true
				hideDownloadButton: true
				requiredPropsFirst: true
				sortTagsAlphabetically: true
				sortOperationsAlphabetically: true
				theme:
					rightPanel:
						# From variables.less @colorPurpleDark3
						backgroundColor: '#1f2354'
			},
			angular.element('#redoc-container')[0]
		)
